/** LookupEnums (LE) must align with their associated Lookups. The associated Lookups must be marked as immutable.
 * Name the enum for the LookupGroup's Code. Name the keys to align with the Lookup's Code. The values should align with the Lookup's Murn.
 */
export namespace LE {
  export enum DocumentCategory {
    Facility = "murn:ust:lookup/DocumentCategory/Facility",
    Tank = "murn:ust:lookup/DocumentCategory/Tank",
    ComplianceAction = "murn:ust:lookup/DocumentCategory/ComplianceAction",
  }
  export enum StateCategory {
    HI = "murn:ust:lookup/State/HI",
  }
}
